import { motion } from 'framer-motion'

import { StepWrapper } from './Step.styles'

interface StepProps {
  children: React.ReactNode
  padded?: boolean
}

const Step = ({ children, padded }: StepProps) => {
  return (
    <StepWrapper
      as={motion.div}
      padded={padded}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.2
      }}
    >
      {children}
    </StepWrapper>
  )
}

export default Step
